import { ListenerEffectAPI, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { updateGalaxies } from '../galaxy/galaxy';

const galaxyListHandler = (listenerApi: ListenerEffectAPI<unknown, ThunkDispatch<unknown, unknown, UnknownAction>, unknown>, payload: any) => {
  listenerApi.dispatch(updateGalaxies(payload));
}

export default galaxyListHandler;

